const { default: ApiService } = require("./api.service");

// services/message.service.js
const MessageService = {
    getConversations: () => ApiService.fetch('messages/conversations'),
    
    getMessages: (userId) => ApiService.fetch(`messages/${userId}`),
    
    sendMessage: (receiverId, content) => ApiService.fetch('messages/send', {
        method: 'POST',
        body: JSON.stringify({ receiver_id: receiverId, content })
    }),
    
    markAsRead: (userId) => ApiService.fetch(`messages/${userId}/read`, {
        method: 'PUT'
    }),

    deleteUserMessages: (userId) => ApiService.fetch(`messages/${userId}`, {
        method: 'DELETE'
    })
};

export default MessageService;